module.exports = __webpack_public_path__ + "static/media/migCompletaOk.96abc2da.svg";